import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { FiAlignRight, FiXCircle, FiChevronDown } from "react-icons/fi";
import "../HomeFolder/HomeNavbarmenu.css";
import "./LTTPodcastNavbarmenu.css";
import marketOrTrackList from "./TracksDropdownData.js";
import { useMsal } from "@azure/msal-react";

const LTTPodcastNavbarmenu = () => {
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  let loggedInEnterpriseId = "";
  if (activeAccount)
    loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
  const allowedUsers = [
    "arpita.m.singh",
    "varsha.a.tyagi",
    "h.srinivasan",
    "aluru.akash",
    "aayushi.bharti",
    "ankur.e.mishra",
    "uma.rani.battu",
    "srikanth.narabathoju",
    "reshmi.haridas.m",
    "jeevadharani.ramanan",
    "kusume.sridhar",
  ];

  const [isMenu, setisMenu] = useState(false);
  const [isResponsiveclose, setResponsiveclose] = useState(false);
  const toggleClass = () => {
    setisMenu(isMenu === false ? true : false);
    setResponsiveclose(isResponsiveclose === false ? true : false);
  };
  let boxClass = ["main-menu"];
  if (isMenu) {
    boxClass.push("menuq2");
  } else {
    boxClass.push("");
  }

  return (
    <header className="header__middle">
      <div className="head-container">
        <div className="row">
          <div className="header__middle__menus">
            <nav className="main-nav">
              {/* Responsive Menu Button */}
              {isResponsiveclose === true ? (
                <span
                  className="menubar__button"
                  style={{ display: "none" }}
                  onClick={toggleClass}
                >
                  <FiXCircle />
                </span>
              ) : (
                <span
                  className="menubar__button"
                  style={{ display: "none" }}
                  onClick={toggleClass}
                >
                  <FiAlignRight />
                </span>
              )}
              <ul className={boxClass.join(" ")}>
                <li className="menu-item">
                  <NavLink
                    activeClassName="is-active"
                    // className="nav-links icon-symbol"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/LTT-Podcast`}
                  >
                    {/* <img
                      src="images/Podcast/Podcast-active-icon.png"
                      alt="home"
                      className="home-active"
                    />
                    <img
                      src="images/Podcast/Podcast-inactive-icon.png"
                      alt="home"
                      className="home-inactive"
                    /> */}
                    <span>Home</span>
                  </NavLink>
                </li>
                <li className="menu-item">
                  <a
                    href="/LTT-Podcast#Library"
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    exact
                  >
                    <span>Library</span>
                  </a>
                </li>
                <li className="menu-item dropdown">
                  <NavLink
                    to="/Tracks-Markets"
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    exact
                  >
                    <span>
                      Tracks/Markets{" "}
                      <span className="dropdown-arrow">
                        <FiChevronDown />
                      </span>
                    </span>
                  </NavLink>
                  <div className="tracks-dropdown-box">
                    <ul>
                      {marketOrTrackList.map((group, index) => (
                        <React.Fragment key={`group-${index}`}>
                          <li className="sub-headings">{group.group}</li>
                          {group.sub_list.map((item, subIndex) => (
                            <li
                              key={`item-${index}-${subIndex}`}
                              value={item}
                              tabIndex="0"
                            >
                              {item}
                            </li>
                          ))}
                        </React.Fragment>
                      ))}
                    </ul>
                  </div>
                </li>
                <li className="menu-item">
                  <NavLink
                    to="/Resources"
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    exact
                  >
                    <span>Resources</span>
                  </NavLink>
                </li>
                <li className="menu-item">
                  <NavLink
                    to="/FAQs"
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    exact
                  >
                    <span>FAQs</span>
                  </NavLink>
                </li>
                {allowedUsers.includes(loggedInEnterpriseId) && (
                  <li className="menu-item">
                    <NavLink
                      to="/Feedback"
                      activeClassName="is-active"
                      className="nav-links"
                      onClick={toggleClass}
                      exact
                    >
                      <span>Admin</span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default LTTPodcastNavbarmenu;
